import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useLayoutStore = create(
  persist(
    (set) => ({
      sidebarCollapse: false,
      pending: false,

      setSidebarCollapse: (collapsed) => set({ sidebarCollapse: collapsed }),
      toggleSidebarCollapse: () => set((state) => ({ sidebarCollapse: !state.sidebarCollapse })),
      setPending: (pending) => set({ pending }),
    }),
    {
      name: 'layout',
      partialize: (state) => ({ sidebarCollapse: state.sidebarCollapse }),
    }
  )
);
